export const DELIMITER = ';';
export const ARRAY_REG = /^\[.+]$/;
export const EXTRACT_VALUES_REG = /(\w+)\[([^\]]+)]([^;]+)?/g;
export const PARAM_KEYS = {
    filter: 'filter',
    sort: 'sort',
    pagination: 'pagination',
    search: 'search',
};
export const PAGINATION_KEYS = {
    offset: 'offset',
    limit: 'limit',
};
export const SORT_DIRECTION = ['asc', 'desc'];
export const SINGLE_VALUE_CONDITIONS = ['eq', 'neq', 'lt', 'lte', 'gt', 'gte', 'include', 'noInclude'];
export const MULTI_VALUE_CONDITIONS = ['in', 'notIn'];
export const FILTER_CONDITION = [...SINGLE_VALUE_CONDITIONS, ...MULTI_VALUE_CONDITIONS];
